import { Typography, Link, Box } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { Documents } from '@features/workspace/components/document-list';
import { LabelValueList } from '@features/workspace/components/label-value-list';
import { ActionLinkEdit } from '@features/workspace/components/controls/action-link';
import { EmployeePositionLabelEnum } from '@utils/constants';
import { useAppSelector } from '@store/hooks';
import {
  selectActiveCompany,
  selectPrimaryUser,
  selectDocumentsFilterBusiness,
} from '@features/workspace/store/selectors';
import ChangePrimaryUserDialog from './dialogs/change-primary-user-dialog';
import config from '@/app/configs/config';

export function CompanyView() {
  const company = useAppSelector(selectActiveCompany);
  const primaryUser = useAppSelector(selectPrimaryUser);
  const businessDocuments = useAppSelector(selectDocumentsFilterBusiness);
  const [isChangePrimaryUserOpen, setChangePrimaryUserOpen] = useState(false);

  const properties: Array<any> = [
    { label: 'Registered business name', value: company?.name || null },
    {
      label: 'Registration number',
      value: company?.registrationNumber || null,
    },
    { label: 'Company ID', value: company?.id || null },
    { label: 'Tax number', value: company?.taxNumber || null },
    { label: 'VAT number', value: company?.vatRegistrationNumber || null },
    {
      label: 'Registration date',
      value: company?.businessRegistrationDate
        ? moment(company?.businessRegistrationDate).format(config.dateFormat)
        : null,
    },
    {
      label: 'Primary user',
      value: (
        <Box display="flex" flexDirection="column">
          {[primaryUser?.person?.firstName, primaryUser?.person?.lastName].join(
            ' '
          )}
          &nbsp;
          {!!primaryUser?.assignment?.position && (
            <Typography sx={{ color: '#838383' }} variant="caption">
              {EmployeePositionLabelEnum[primaryUser?.assignment?.position]}
            </Typography>
          )}
        </Box>
      ),
    },
    { label: 'Primary user phone', value: primaryUser?.phoneNumber || null },
    { label: 'Primary user email', value: primaryUser?.email || null },
    {
      label: 'Website',
      value: company?.website ? (
        <Link href={company?.website} target="_blank">
          {company?.website}
        </Link>
      ) : null,
    },
  ];

  if (primaryUser?.isBlocked) {
    properties.push({ label: 'Blacklist', value: 'Currently blacklisted' });
  }

  return (
    <>
      <Box alignItems="center" display="flex">
        <Box display="flex">
          <Typography variant="h6">Company Information</Typography>
        </Box>
        <Box display="flex" ml={3}>
          <ActionLinkEdit uri="/customer/company/edit">Edit</ActionLinkEdit>
        </Box>
      </Box>

      <Box mb={3} mt={2.5}>
        <LabelValueList properties={properties} />
        <Box display="flex" mt={1}>
          <ActionLinkEdit onClick={() => setChangePrimaryUserOpen(true)}>
            Change primary user
          </ActionLinkEdit>
        </Box>
      </Box>

      <Box display="flex" mb={2} ml={0}>
        <Typography variant="h6">Business documents</Typography>
      </Box>
      <Documents
        showVerifiedLabel
        items={businessDocuments}
        showModifiedDate={false}
      />
      <ChangePrimaryUserDialog
        open={isChangePrimaryUserOpen}
        onClose={() => setChangePrimaryUserOpen(false)}
      />
    </>
  );
}
